import { combineReducers } from 'redux'
import {
  addCalendarDataReducer,
  addAvailabilityDataReducer,
  addHolidayDataReducer,
  addHolidayResponseReducer,
  editHolidayResponseReducer,
  deleteHolidayResponseReducer,
} from './Calendar/CalendarDataReducers'
import {
  setReportDiagnosisDataReducer,
  setCategorizedDataReducer,
  setReportCommentsDataReducer,
  setCommentObjectsListDataReducer,
  saveDraftReportReducer,
  setDraftReportDataReducer,
  addTrfInfoReducer,
  setSlideDiagnosisOptionsReducer,
  setImageQualityOptionsReducer,
  getCaseDataReducer,
  selectImageForReportReducer,
  setShowingRectReducer,
  setAllSlidesReducer,
  addSampleLocationDataReducer,
  addSummaryTreeDataReducer,
  addBarcodeDataReducer,
  addClinicalInfoReducer,
  saveSlideDiagnosisDataReducer,
  getSlideDiagnosisDataReducer,
  getReportHistoryDataReducer,
  setReportDataReducer,
  setPatientHistoryReducer,
  saveReportDataResponseReducer,
  amendReportUploadReducer,
  getCPTCodesDataReducer,
  getPDFBytesReducer,
  getPathologistsListResponseReducer,
  consultResponseReducer,
  consultCompleteResponseReducer,
  getPathologistsListReducer,
  setSignedUrlToGetReportReducer,
  setCaseDiagnosisReducer,
  setSignedURLToSaveReportReducer,
  setSignedUrlToGetTrfReducer,
  setURLForReportPDFReducer,
  getSaveStateReducer,
  refreshCaseReducer,
  refreshCaseResponseReducer,
  auditClassifierAccessedReducer,
} from './Premeris/PremerisDataReducers'
import {
  addInboxDataReducer,
  addCaseDetailsReducer,
  addPendingDataReducer,
  addCompletedDataReducer,
  addRecentlyReleasedDataReducer,
  receivePathologistsSlidesDataReducer,
  completeCaseDataResponseReducer,
  launchPremerisDataResponseReducer,
  filterPayloadResponseReducer,
  freezeCaseReducer,
} from './CaseWorklist/addPathologistDataReducer'
import { getCaseHistoryDataReducer } from './CaseWorklist/getCaseHistoryDataReducer'
import {
  getReadyForPickupDataReducer,
  getDispatchDataReducer,
  getInProgressDataReducer,
  getCompleteDataReducer,
  receiveSlidesDataReducer,
  receiveSlidesDataResponseReducer,
  sendSlidesDataResponseReducer,
  errorMessageReducer,
} from './CaseWorklist/getLogisticsDataReducer/getLogisticsDataReducer'
import {
  getITAdminUnassignedDataReducer,
  getITAdminAssignedDataReducer,
  getITAdminQCCasesDataReducer,
  getITAdminCompleteDataReducer,
  getITAdminSettingsDataReducer,
  getITAdminStateDataReducer,
  deleteSettingResponseReducer,
  addSettingResponseReducer,
  editSettingResponseReducer,
  addStateResponseReducer,
  deleteStateResponseReducer,
  editStateResponseReducer,
} from './CaseWorklist/getITAdminDataReducer'
import {
  getSearchByTRFDataReducer,
  searchDataResponseReducer,
} from './CaseWorklist/getSearchByTRFDataReducer/getSearchByTRFDataReducer'
import {
  addReportingInfoReducer,
  addLoadBalanceLogInfoReducer,
  addQCLogInfoReducer,
  addReportUploadReducer,
} from './reporting'
import {
  getUnassignedDataReducer,
  getAssignedDataReducer,
  getQCCasesDataReducer,
  getLabManagerCompleteDataReducer,
  getLabTransferListReducer,
  transferResponseReducer,
  correctionResponseReducer,
  amendResponseReducer,
  unassignResponseReducer,
  getLabTransferListResponseReducer,
} from './getLabManagerDataReducer'

import { addUserDropDownReducer } from './addUserDropDown/addUserDropDownReducer'
import { addProfileDataReducer } from './UserManagement/addProfileDataReducer'
import {
  getUsersDataReducer,
  deleteUserDataReducer,
  getUsersByGroupIdReducer,
  getUsersListByGroupIdReducer,
  getsessionStatusReducer,
  getTokenActiveStatusReducer,
} from './UserManagement/getUsersDataReducer'
import { getUserProfileDataReducer, getUserListMinimalDataReducer } from './UserManagement/getUserProfileDataReducer'
import { addUserLoginData, addFilterProcedureCodeData } from './UserManagement/addUserLoginData'
import { appConfigurations, appCredentials } from './Generic/appConfigurations'
import { addUser, editUser } from './UserManagement/AddUser'
const appReducer = combineReducers({
  userLogin: addUserLoginData,
  calendarData: addCalendarDataReducer,
  allUsersAvailability: addAvailabilityDataReducer,
  addHolidayData: addHolidayDataReducer,
  inboxData: addInboxDataReducer,
  recentlyReleasedData: addRecentlyReleasedDataReducer,
  caseDetails: addCaseDetailsReducer,
  profileData: addProfileDataReducer,
  getUsers: getUsersDataReducer,
  getUserProfile: getUserProfileDataReducer,
  getUsersByGroupId: getUsersByGroupIdReducer,
  getUsersListByGroupId: getUsersListByGroupIdReducer,
  deleteUser: deleteUserDataReducer,
  appConfig: appConfigurations,
  appCredentials: appCredentials,
  getCaseHistory: getCaseHistoryDataReducer,
  getDispatchData: getDispatchDataReducer,
  getReadyForPickupData: getReadyForPickupDataReducer,
  getInProgressData: getInProgressDataReducer,
  getCompleteData: getCompleteDataReducer,
  pendingData: addPendingDataReducer,
  completedData: addCompletedDataReducer,
  receiveSlideData: receiveSlidesDataReducer,
  sendSlideData: receiveSlidesDataReducer,
  getUserListMinimalData: getUserListMinimalDataReducer,
  addUserDropDown: addUserDropDownReducer,
  getUnassignedData: getUnassignedDataReducer,
  getAssignedData: getAssignedDataReducer,
  getQCCasesData: getQCCasesDataReducer,
  getLabManagerCompleteData: getLabManagerCompleteDataReducer,
  addLabTransferList: getLabTransferListReducer,
  getReadyForPickupDataReducerPathologists: receivePathologistsSlidesDataReducer,
  getITAdminUnassignedData: getITAdminUnassignedDataReducer,
  getITAdminAssignedData: getITAdminAssignedDataReducer,
  getITAdminQCCasesData: getITAdminQCCasesDataReducer,
  getITAdminCompleteData: getITAdminCompleteDataReducer,
  addSearchData: getSearchByTRFDataReducer,
  getITAdminSettingsData: getITAdminSettingsDataReducer,
  getITAdminStateData: getITAdminStateDataReducer,
  getFilterProcedureCodeData: addFilterProcedureCodeData,
  addUser: addUser,
  editUser: editUser,
  fetchReportingData: addReportingInfoReducer,
  fetchLoadBalanceLog: addLoadBalanceLogInfoReducer,
  fetchQCAssignmentLog: addQCLogInfoReducer,
  fetchReportUploadLog: addReportUploadReducer,
  receiveSlidesDataResponse: receiveSlidesDataResponseReducer,
  sendSlidesDataResponse: sendSlidesDataResponseReducer,
  searchDataResponse: searchDataResponseReducer,
  completeCaseDataResponse: completeCaseDataResponseReducer,
  launchPremerisDataResponse: launchPremerisDataResponseReducer,
  filterPayloadResponse: filterPayloadResponseReducer,
  deleteSettingResponse: deleteSettingResponseReducer,
  transferResponse: transferResponseReducer,
  correctionResponse: correctionResponseReducer,
  amendResponse: amendResponseReducer,
  unassignResponse: unassignResponseReducer,
  getLabTransferListResponse: getLabTransferListResponseReducer,
  addSettingResponse: addSettingResponseReducer,
  addStateResponse: addStateResponseReducer,
  deleteStateResponse: deleteStateResponseReducer,
  editStateResponse: editStateResponseReducer,
  editSettingResponse: editSettingResponseReducer,
  addHolidayResponse: addHolidayResponseReducer,
  editHolidayResponse: editHolidayResponseReducer,
  deleteHolidayResponse: deleteHolidayResponseReducer,
  setReportDiagnosisData: setReportDiagnosisDataReducer,
  setCategorizedData: setCategorizedDataReducer,
  setReportCommentsData: setReportCommentsDataReducer,
  setCommentObjectsListData: setCommentObjectsListDataReducer,
  addTrfInfo: addTrfInfoReducer,
  setSlideDiagnosisOptions: setSlideDiagnosisOptionsReducer,
  setImageQualityOptions: setImageQualityOptionsReducer,
  getCaseData: getCaseDataReducer,
  selectImageForReport: selectImageForReportReducer,
  setShowingRect: setShowingRectReducer,
  addSampleLocationData: addSampleLocationDataReducer,
  addSummaryTreeData: addSummaryTreeDataReducer,
  setAllSlides: setAllSlidesReducer,
  addBarcodeData: addBarcodeDataReducer,
  getsessionStatus: getsessionStatusReducer,
  getTokenStatus: getTokenActiveStatusReducer,
  addClinicalInfo: addClinicalInfoReducer,
  saveSlideDiagnosisData: saveSlideDiagnosisDataReducer,
  getSlideDiagnosisData: getSlideDiagnosisDataReducer,
  getReportHistoryData: getReportHistoryDataReducer,
  setReportData: setReportDataReducer,
  setPatientHistory: setPatientHistoryReducer,
  getCPTCodesData: getCPTCodesDataReducer,
  saveReportDataResponse: saveReportDataResponseReducer,
  saveAmendResponse: amendReportUploadReducer,
  errorMessage: errorMessageReducer,
  saveDraftReport: saveDraftReportReducer,
  setDraftReportData: setDraftReportDataReducer,
  getPDFBytes: getPDFBytesReducer,
  addPathologistsList: getPathologistsListReducer,
  getPathologistsListResponse: getPathologistsListResponseReducer,
  updateConsultResponse: consultResponseReducer,
  updateConsultCompleteResponse: consultCompleteResponseReducer,
  setSignedUrlToGetReport: setSignedUrlToGetReportReducer,
  setCaseDiagnosis: setCaseDiagnosisReducer,
  setSignedURLToSaveReport: setSignedURLToSaveReportReducer,
  setSignedUrlToGetTrf: setSignedUrlToGetTrfReducer,
  setURLForReportPDF: setURLForReportPDFReducer,
  getSaveState: getSaveStateReducer,
  tokenActiveStatus: getTokenActiveStatusReducer,
  refreshCase: refreshCaseReducer,
  refreshResponse: refreshCaseResponseReducer,
  updateFreezeReportStatus: freezeCaseReducer,
  auditClassifier: auditClassifierAccessedReducer,
})

export const rootReducer = (state, action) => {
  if (action.type === 'USER_LOGOUT') {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export type RootState = ReturnType<typeof rootReducer>
